import styled from '@emotion/styled'
import { GridCell } from '@mobi/component-library/Legacy/Grid'

export const SameRaceMultiQuickbetStyled = styled(GridCell)({
  paddingTop: '2px', // price row above also has margin/padding
})
